import React, { useRef, useLayoutEffect } from 'react';
import { isEnterPressed, isSpacePressed } from 'app/utils/accessibility/accessibilityUtils';
import Region from './region';

function useClickOutside(isOpen, setIsOpen) {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const onClickOutsideDropdown = e => {
      const insideDropdownComponent = e.target.closest(`#${ref.current.id}`);
      if (!insideDropdownComponent) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('click', onClickOutsideDropdown);
    }
    return () => {
      document.removeEventListener('click', onClickOutsideDropdown);
    };
  }, [setIsOpen, isOpen]);

  return ref;
}

const Dropdown = ({ isOpen, setIsOpen, onDropdownClick, selectedItem, dropdownList, onItemClick }) => {
  const dropdownRef = useClickOutside(isOpen, setIsOpen);
  const buttonRef = useRef(null);

  const handleSelection = id => {
    onItemClick(dropdownList.find(i => i.id === id));
    buttonRef.current.focus();
  };

  return (
    <div className="new-dropdown-container" id="dropdown-container" ref={dropdownRef}>
      <div className="new-dropdown">
        <button
          ref={buttonRef}
          className="new-dropdown__toggle"
          id="dropdownMenuButton"
          type="button"
          aria-haspopup="true"
          aria-expanded={isOpen}
          onClick={onDropdownClick}
        >
          <Region id={selectedItem.id} name={selectedItem.name} />
        </button>
        {isOpen && (
          <ul className="new-dropdown__menu" aria-labelledby="dropdownMenuButton">
            {dropdownList
              .filter(i => i.id !== selectedItem.id)
              .map(({ id, name }) => {
                return (
                  <li
                    tabIndex={0}
                    role="option"
                    aria-selected={id === selectedItem.id}
                    className={`new-dropdown__item ${isOpen ? 'isOpen' : ''}`}
                    onKeyDown={e => {
                      if (isEnterPressed(e) || isSpacePressed(e)) {
                        handleSelection(id);
                      }
                    }}
                    onClick={() => handleSelection(id)}
                    key={id}
                  >
                    <Region id={id} name={name} />
                  </li>
                );
              })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Dropdown;
